import React, { useState } from 'react';

function ShortUrlModal({ open, onClose, onSave }) {
  const [url, setUrl] = useState('');

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 style={{ marginTop: 0 }}>Shorten URL</h2>
        <input
          type="text"
          value={url}
          onChange={e => setUrl(e.target.value)}
          placeholder="Paste a long URL here..."
          className="input"
          style={{ width: '100%', marginBottom: 16 }}
        />
        <div className="modal-actions">
          <button onClick={onClose} className="btn btn-secondary">Cancel</button>
          <button onClick={() => { onSave(url); setUrl(''); }} className="btn btn-primary">Shorten</button>
        </div>
      </div>
    </div>
  );
}

export default ShortUrlModal;
